var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaphireTier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "avatars"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_36801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_36801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_36801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M23.9408 12C23.9408 18.5947 18.5947 23.9408 12 23.9408C5.40528 23.9408 0.0592105 18.5947 0.0592105 12C0.0592105 5.40528 5.40528 0.0592105 12 0.0592105C18.5947 0.0592105 23.9408 5.40528 23.9408 12Z",
    fill: "#E5E8ED",
    stroke: "#E5E8ED",
    strokeWidth: 0.118421
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xEF\xA2\x90",
    d: "M15.1243 4.28678L15.8665 4.00033L16.1399 3.27116C16.153 3.20605 16.2181 3.16699 16.2832 3.16699C16.3352 3.16699 16.4004 3.20605 16.4134 3.27116L16.6998 4.00033L17.429 4.28678C17.4941 4.2998 17.5332 4.36491 17.5332 4.41699C17.5332 4.4821 17.4941 4.5472 17.429 4.56022L16.6998 4.83366L16.4134 5.57585C16.4004 5.62793 16.3352 5.66699 16.2832 5.66699C16.2181 5.66699 16.153 5.62793 16.1399 5.57585L15.8665 4.83366L15.1243 4.56022C15.0592 4.5472 15.0332 4.4821 15.0332 4.41699C15.0332 4.36491 15.0592 4.2998 15.1243 4.28678ZM7.54618 4.28158L9.03056 4.95866C9.10868 4.99772 9.16077 5.07585 9.16077 5.15397C9.16077 5.2321 9.10868 5.31022 9.03056 5.34928L7.54618 6.02637L6.8691 7.51074C6.83004 7.58887 6.75191 7.64095 6.67379 7.64095C6.59566 7.64095 6.51754 7.58887 6.4915 7.51074L5.80139 6.02637L4.31702 5.34928C4.23889 5.31022 4.19983 5.2321 4.19983 5.15397C4.19983 5.07585 4.23889 4.99772 4.31702 4.95866L5.80139 4.28158L6.4915 2.7972C6.51754 2.71908 6.59566 2.66699 6.67379 2.66699C6.75191 2.66699 6.83004 2.71908 6.8691 2.7972L7.54618 4.28158ZM18.8066 6.10449C18.8196 6.03939 18.8847 6.00033 18.9498 6.00033C19.0019 6.00033 19.067 6.03939 19.08 6.10449L19.3665 6.83366L20.0957 7.12012C20.1608 7.13314 20.1998 7.19824 20.1998 7.25033C20.1998 7.31543 20.1608 7.38053 20.0957 7.39356L19.3665 7.66699L19.08 8.40918C19.067 8.46126 19.0019 8.50033 18.9498 8.50033C18.8847 8.50033 18.8196 8.46126 18.8066 8.40918L18.5332 7.66699L17.791 7.39356C17.7259 7.38053 17.6998 7.31543 17.6998 7.25033C17.6998 7.19824 17.7259 7.13314 17.791 7.12012L18.5332 6.83366L18.8066 6.10449Z",
    fill: "#7F8FA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    d: "M12 21.333C15.6819 21.333 18.6667 20.4376 18.6667 19.333C18.6667 18.2284 15.6819 17.333 12 17.333C8.31814 17.333 5.33337 18.2284 5.33337 19.333C5.33337 20.4376 8.31814 21.333 12 21.333Z",
    fill: "#B3BCC7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x8E\xA5",
    d: "M15.444 8.32143L17.5797 11.4286H13.126L15.444 8.32143ZM12.1363 11.375L9.63599 8H14.6106L12.1363 11.375ZM8.80255 8.32143L11.1205 11.4286H6.66687L8.80255 8.32143Z",
    fill: "url(#paint0_diamond_107_36801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x8E\xA5_2",
    d: "M12.4114 17.3333L7.73328 12H17.0666L12.4114 17.3333Z",
    fill: "url(#paint1_diamond_107_36801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x8E\xA5_3",
    d: "M18.6025 11.1402L15.6855 6.85449C15.6074 6.74735 15.4772 6.66699 15.3469 6.66699H8.65339C8.52317 6.66699 8.39294 6.74735 8.31481 6.85449L5.39778 11.1402C5.2936 11.3277 5.31964 11.542 5.44987 11.6759L11.7006 18.5331C11.7788 18.6402 11.883 18.667 12.0132 18.667C12.1174 18.667 12.2215 18.6402 12.2997 18.5331L18.5505 11.6759C18.6807 11.542 18.7067 11.3009 18.6025 11.1402ZM15.3209 7.84556L17.4566 10.9527H13.0029L15.3209 7.84556ZM12.0132 10.8991L9.51287 7.52414H14.4875L12.0132 10.8991ZM8.67944 7.84556L10.9974 10.9527H6.54376L8.67944 7.84556ZM12.0132 17.6224L6.70002 11.8098H17.3003L12.0132 17.6224Z",
    fill: "#7F8FA4"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_107_36801",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8264 13.9026) rotate(90) scale(5.04911 5.45641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D9396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABEC0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_diamond_107_36801",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6669 12) rotate(90) scale(6 3.56499)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D9396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABEC0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_36801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaphireTier);
export default __webpack_public_path__ + "static/media/saphire_tier.e7e439e3.svg";
export { ForwardRef as ReactComponent };